import Feed from 'redhotpie-shared-lib/models/newFeedItem';
import * as types from '../constants/actionTypes';
import { IParamsRequest } from '../interfaces/IAction';
import { IApiResponse } from '../interfaces/IApiResponse';
import newFeedService from '../services/newFeedService';
import { Dispatch } from 'redux';
import { IActivityFilterItem } from 'redhotpie-shared-lib/interfaces/IStream';

export function getDataHomeSuccess(data: Feed[], dataPinnedContent: Feed[], dataDateFinder: Feed[], params: IParamsRequest) {
  return { type: types.GET_DATA_HOME_PAGE_SUCCESS, data, dataPinnedContent, dataDateFinder, params };
}

export function mergeDataHome(data: any) {
  return { type: types.MERGE_DATA_HOME_PAGE_SUCCESS, data };
}

export function getActivitySumarySuccess(data: any) {
  return { type: types.GET_ACTIVITY_SUMARY_USERS_SUCCESS, data };
}

export function getRecentSuccess(data: any) {
  return { type: types.GET_RECENT_SUCCESS, data };
}

export function getDataHomePageError(message: string) {
  return { type: types.GET_DATA_HOME_PAGE_ERROR, message };
}

export function updateNewFeedState(dataKey: string[], data: any) {
  return { type: types.UPDATE_NEW_FEED_STATE, dataKey, data };
}

export function resetErrorState() {
  return (dispatch: Dispatch) => {
    dispatch({ type: types.RESET_HOME_ERROR_STATUS });
  };
}

export function getAnnouncementBannerSuccess(data: any, data2: any) {
  return { type: types.GET_ANNOUNCEMENT_BANNER_SUCCESS, data, data2 };
}

export function toggleTestimonialModal(toggle: boolean, data?: any) {
  return { type: types.TOGGLE_TESTIMONIAL_MODAL, toggle, data };
}

export function getUsersHomePage(params: IParamsRequest) {
  return (dispatch: Dispatch) => {
    dispatch(
      mergeDataHome({
        isLoadingNewFeed: !!(params && !params.loadMore) || !params,
        pageNumber: params.page ? params.page : 1,
        isLoadMore: !!params.loadMore,
      })
    );
    return newFeedService.getDataPageHome(params).then((res: IApiResponse<any>) => {
      if (res && res.success) {
        dispatch(getDataHomeSuccess(res.data, [], [], params));
      } else {
        dispatch(getDataHomePageError(res.message || ''));
        console.log('ERROR: newFeedAction/getDataPageHome', res.message);
      }
      return res;
    });
  };
}

export function getUsersHomePageWithPinnedContent(params: IParamsRequest) {
  return (dispatch: Dispatch, getState: any) => {
    dispatch(
      mergeDataHome({
        isLoadingNewFeed: (params && !params.loadMore) || !params,
        pageNumber: params.page ? params.page : 1,
        isLoadMore: !!params.loadMore,
      })
    );
    const { loginReducer } = getState();
    const activityFilters = loginReducer?.userInfo?.streamSettings?.activityFilters;
    let newParams = { ...params, Filter: [] };
    let isSelectedAll = true;
    if (activityFilters) {
      isSelectedAll = activityFilters.filter((itm: IActivityFilterItem) => itm.isSelected).length === activityFilters.length;
    }
    if (!isSelectedAll) {
      newParams.Filter = activityFilters.filter((itm: IActivityFilterItem) => itm.isSelected).map((itm: IActivityFilterItem) => itm.id);
    }
    return newFeedService.getDataPageHomeWithPinnedContent(newParams).then((res: IApiResponse<Feed[]>) => {
      if (res && res.success) {
        dispatch(getDataHomeSuccess(res.data || [], res.dataPinnedContent || [], res.dataDateFinder || [], params));
      } else {
        dispatch(getDataHomePageError(res.message || ''));
        console.log('ERROR: newFeedAction/getDataPageHome', res.message);
      }
      return res;
    });
  };
}

export function getActivitySumaryUsers() {
  return (dispatch: Dispatch) => {
    dispatch(
      mergeDataHome({
        isLoadingActivitySumaryUsers: true,
        isCallAPINewFeedIgnoreTimeout: false,
      })
    );
    return newFeedService.getActivitySumaryUser().then((res: IApiResponse<any>) => {
      if (res && res.success) {
        dispatch(getActivitySumarySuccess(res.data));
      } else {
        dispatch(getDataHomePageError((res && res.message) || ''));
        dispatch(getActivitySumarySuccess({ activeUsers: [], newUsers: [] }));
        console.log('ERROR: newFeedAction/getActivitySumaryUsers', (res && res.message) || '');
      }
      return res;
    });
  };
}

export function getDateFinderCount() {
  return (dispatch: Dispatch) => {
    return newFeedService.getDateFinderCount().then((res: IApiResponse<any>) => {
      if (res && res.success) {
        dispatch(updateNewFeedState(['dateFinder'], res.data));
      } else {
        dispatch(
          updateNewFeedState(['dateFinder'], {
            myDate: 0,
            totalDates: 0,
            matchingDates: 0,
          })
        );
        console.log('ERROR: newFeedAction/getDateFinderCount', res.message);
      }
      return res;
    });
  };
}

export function getActiveUsersCount() {
  return (dispatch: Dispatch) => {
    return newFeedService.getActiveUsersCount().then((res: IApiResponse<any>) => {
      if (res && res.success) {
        dispatch(updateNewFeedState(['activeUsers'], res.data));
      } else {
        dispatch(
          updateNewFeedState(['activeUsers'], {
            total: 0,
            favorites: 0,
            friends: 0,
          })
        );
        console.log('ERROR: newFeedAction/getActiveUsersCount', res.message);
      }
      return res;
    });
  };
}

export function getProspectsSummaryCount() {
  return (dispatch: Dispatch) => {
    return newFeedService.getProspectSummaryCount().then((res: IApiResponse<any>) => {
      if (res && res.success) {
        dispatch(updateNewFeedState(['prospectsSummary'], res.data));
      } else {
        dispatch(
          updateNewFeedState(['prospectsSummary'], {
            recentViews: 0,
            thisMonthViews: 0,
            favoritedMe: 0,
            haveFavourited: 0,
            matches: 0,
          })
        );
        console.log('ERROR: newFeedAction/getProspectsSummaryCount', res.message);
      }
      return res;
    });
  };
}

export function getListCurrentCompetitions() {
  return (dispatch: Dispatch) => {
    return newFeedService.getListCurrentCompetitions().then((res: IApiResponse<any>) => {
      if (res && res.success) {
        dispatch(updateNewFeedState(['dataCompetitions'], res.data));
      } else {
        dispatch(updateNewFeedState(['dataCompetitions'], []));
        console.log('ERROR: newFeedAction/getListCurrentCompetitions', res && res.message);
      }
      return res;
    });
  };
}

export function getRecent() {
  return (dispatch: Dispatch) => {
    dispatch(
      mergeDataHome({
        isLoadingRecent: true,
      })
    );
    return newFeedService.getRecent().then((res: IApiResponse<any>) => {
      if (res && res.success) {
        dispatch(getRecentSuccess(res.data));
      } else {
        dispatch(getDataHomePageError((res && res.message) || 'API ERROR'));
        console.log('ERROR: newFeedAction/getRecent', (res && res.message) || 'API ERROR');
      }
      return res;
    });
  };
}

export function getAnnouncementBanner() {
  return (dispatch: Dispatch) => {
    return newFeedService.getAnnouncementBanner().then((res: IApiResponse<any>) => {
      if (res && res.success) {
        dispatch(getAnnouncementBannerSuccess(res.data, res.dataDesktop));
      } else {
        console.log('ERROR: newFeedAction/getAnnouncementBanner', res || 'API ERROR');
        dispatch(getAnnouncementBannerSuccess(null, null));
      }
      return res;
    });
  };
}
